import { render, staticRenderFns } from "./LayoutPaymentLink.vue?vue&type=template&id=0be050c7"
import script from "./LayoutPaymentLink.vue?vue&type=script&lang=js"
export * from "./LayoutPaymentLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports